<template>
    <v-col :cols="cols" :sm="sm" :md="md" class="py-1">
        <validation-provider :name="label" :rules="rules" v-slot="{ errors }">
            <label class="form-label">
                {{ label }} <span v-if="requiredClass">*</span>
            </label>
            <v-radio-group :value="value" row       @change="$emit('change')"
            :background-color="disabled ? 'blue-grey lighten-5' : 'white'"
                            :error-messages="errors[0]"
                           
                            @input="$emit('input', $event)"
                         >
                <!-- <v-radio v-for="item in items" :label="item.label" :value="item.value"></v-radio> -->

            </v-radio-group>
        </validation-provider>
    </v-col>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Number, Array],
            default: "",
        },
        label: {
            type: String,
            required: true,
        },
        rules: {
            type: [String, Object],
            default: "",
        },
        items: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        cols: {
            type: Number,
            default: 12,
        },
        sm: {
            type: Number,
            default: 6,
        },
        md: {
            type: Number,
            default: 3,
        },
    },
    computed: {
        requiredClass() {
            return this.rules.includes("required");
        },
    },
};
</script>